<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader media full>
      <TextHeading variant="subtitle" color="white" class="media-centre__subtitle">On Brand</TextHeading>
      <TextHeading variant="lg" color="white" block>Media Assets</TextHeading>
    </PageHeader>

    <PageGrid>
      <PageMain>
        <PageSection title="Logo and Guidelines">
          <DownloadLogo/>
        </PageSection>
        <PageSection title="Photo Gallery">
          <GridRow cols="3">
            <GridCol>
              <CardGallery title="1 Image Name" image="carrier-bags.jpg" size="2.7Mb"/>
            </GridCol>
            <GridCol>
              <CardGallery title="2 Image Name" image="carrier-bags.jpg" size="1.7Mb"/>
            </GridCol>
            <GridCol>
              <CardGallery title="3 Image Name" image="carrier-bags.jpg" size="3.2Mb"/>
            </GridCol>
            <GridCol>
              <CardGallery title="4 Image Name" image="carrier-bags.jpg" size="12.1Mb"/>
            </GridCol>
            <GridCol>
              <CardGallery title="5 Image Name" image="carrier-bags.jpg" size="0.4Mb"/>
            </GridCol>
            <GridCol>
              <CardGallery title="6 Image Name" image="carrier-bags.jpg" size="5.6Mb"/>
            </GridCol>
          </GridRow>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import CardGallery from '../components/CardGallery.vue'
import GridCol from '../elements/GridCol.vue'
import GridRow from '../elements/GridRow.vue'
import DownloadLogo from '../components/DownloadLogo.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'PageMediaAssets',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    PageGrid,
    PageMain,
    PageSection,
    DownloadLogo,
    GridRow,
    GridCol,
    CardGallery,
    TheFooter
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="postcss">
</style>